export class ServerConfig {
  public static mediaBucket = 'oneclick.media';
  public static cognitoUserPoolId = 'us-west-2_K4dVngaPx';
  public static cognitoClientId = '5mra5m4aa966ghpkhk8kb9p0eh';
  public static gatewayDev = 'yqdrpmgba5.execute-api.us-west-2.amazonaws.com/prod/v1';
  public static gatewayProd = 'yqdrpmgba5.execute-api.us-west-2.amazonaws.com/prod/v1';
  public static socketDev = 'lnb59zhc01.execute-api.us-west-2.amazonaws.com/prod';
  public static socketProd = 'lnb59zhc01.execute-api.us-west-2.amazonaws.com/prod';
}